import React, { useEffect, useState } from "react";
import PopupBottomModal from "../../../../components/popup-bottom-modal";
import { getPrizeText, jumpPage } from "../../../../utils/common";
import { getUserRankingPrize } from "../../utils";
import "./index.less";

interface PrizeShowInfo {
  jumpUrl: string;
  prizeAttribute: Record<string, any>;
  prizeName: string;
  prizeType: number;
  prizeValue: string;
}

interface ActivityNode {
  achieveThreshold: number;
  prizeShowInfoList: PrizeShowInfo[];
}

interface RankGrade {
  maxRanking: number | null;
  minRanking: number;
  prizeShowInfoList: PrizeShowInfo[];
  prizeThreshold: number;
}

interface RankingUser {
  cycleRanking: number | null;
  cycleSuccess: number;
  headImg: string;
}

interface FixedBottomCardProps {
  rank: string;
  inviteCount: number;
  rewardType: string | undefined;
  rewardText: string;
  userInfo: any;
  getUserRewardDetail?: (user: any) => any;
  rankingData?: any; // 添加排行榜数据用于获取奖励配置
  isCurrentCycle: Function;
}

const FixedBottomCard: React.FC<FixedBottomCardProps> = ({
  rank,
  inviteCount,
  rewardType,
  rewardText,
  userInfo,
  getUserRewardDetail,
  rankingData,
  isCurrentCycle
}) => {
  const [showRewardDetail, setShowRewardDetail] = useState(false);
  const [selectedRewardDetail, setSelectedRewardDetail] = useState<any>(null);

  // 获取当前用户对应的排名奖励配置 - 使用公用工具函数
  const getCurrentRankingPrize = (): PrizeShowInfo | null => {
    return getUserRankingPrize(userInfo, rankingData);
  };

  // 关闭奖励详情弹窗
  const handleCloseRewardDetail = () => {
    setShowRewardDetail(false);
  };

  // 处理奖励详情点击
  const handleRewardDetail = () => {
    if (getUserRewardDetail && userInfo) {
      const rewardDetail = getUserRewardDetail(userInfo);
      if(!rewardDetail.rankingReward && !rewardDetail.baseReward && !rewardDetail.stepReward) return
      setSelectedRewardDetail(rewardDetail);
      setShowRewardDetail(true);
    }
  };

  // 处理预计排名奖点击
  const handleRankingRewardClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    const currentRankingPrize = getCurrentRankingPrize();
    if (!currentRankingPrize) return;

    // 判断是否为抽奖机会或活动平台参与机会
    if (currentRankingPrize.prizeType === 4 || currentRankingPrize.prizeType === 13) {
      const jumpUrl = currentRankingPrize.jumpUrl;
      jumpPage(jumpUrl)
    }
  };

  // 判断预计排名奖是否可点击
  const isRankingRewardClickable = (): boolean => {
    const currentRankingPrize = getCurrentRankingPrize();
    if (!currentRankingPrize) return false;

    return (currentRankingPrize.prizeType === 4 || currentRankingPrize.prizeType === 13) &&
           !!currentRankingPrize.jumpUrl;
  };

  return (
    <div className="fixed-bottom-card">
      <div className="card-content" onClick={handleRewardDetail}>
        <div className="user-section">
          <img
            className="avatar"
            src={userInfo?.headImg || require("../../assets/default-head.svg")}
            alt=""
          />
          <div className="user-details">
            <div className="nickname">{userInfo.nickName}</div>
            <div className="rank-info">排名{rank}</div>
          </div>
        </div>

        <div className="invite-count">
          <span className="count">{inviteCount}</span>
          <span className="unit">人</span>
        </div>

      </div>
      <div className="reward-section">
        {!!rewardType && <div
          className={`reward-label`}
          onClick={isRankingRewardClickable() ? handleRankingRewardClick : undefined}
        >
          {`${isCurrentCycle() ? '预计' : ''}排名奖:`}
          <span className={`reward-name ${isRankingRewardClickable() ? 'clickable' : ''}`}>{rewardType}</span>
        </div>}
        {!!rewardText && <div className="reward-content" onClick={handleRewardDetail}>
          <div className="reward-info">
            <div className="reward-icon unlock"></div>
            <div className="reward-text">
              {rewardText}
            </div>
          </div>
          <div className="arrow-right"></div>
        </div>}
      </div>

      {/* 奖励详情弹窗 */}
      <PopupBottomModal
        visible={showRewardDetail}
        onClose={handleCloseRewardDetail}
        title="我的奖励详情"
      >
        <div className="reward-detail-content">
          {selectedRewardDetail && (
            <div>
              {!!selectedRewardDetail.rankingReward && (
                <div>排名奖励: {selectedRewardDetail.rankingReward}</div>
              )}
              {!!selectedRewardDetail.baseReward && <div>基础奖励: {selectedRewardDetail.baseReward}</div>}
              {!!selectedRewardDetail.stepReward && (
                <div>阶梯奖励: {selectedRewardDetail.stepReward}</div>
              )}
            </div>
          )}
        </div>
        <div className="reward-detail-button-container">
          <button
            className="confirm-button"
            onClick={() => setShowRewardDetail(false)}
          >
            确定
          </button>
        </div>
      </PopupBottomModal>
    </div>
  );
};

export default FixedBottomCard;
